import { SubscriptionPeriod } from 'modules/organizer/domain/interfaces/active-tournament-plan';

export function formatSubscriptionPeriod(period: SubscriptionPeriod): string {
  return period === 'YEARLY' ? 'год' : 'месяц';
}
